module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n	<div class=\"prop-header\"><span class=\"prop-label\">Check Mandatory Settings</span></div>\r\n	<table id=\"propMainTable\"></table>\r\n	<div id=\"propMainGridButtons\">\r\n        <button type=\"button\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\" style=\"\">\r\n            <i class=\"fa pf-add\" style=\"\"></i>\r\n        </button>\r\n        <button type=\"button\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\" style=\"\">\r\n            <i class=\"fa pf-delete icon-gradient\"></i>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div><input type=\"radio\" name=\"defaultMessage\" value=\"true\" style=\"margin-right: 5px;\"></input>Show the object&#39;s default mandatory message</div>\r\n    <div><input type=\"radio\" name=\"defaultMessage\" value=\"false\" style=\"margin-right: 5px;\"></input>Show custom message</div>\r\n\r\n    <div>\r\n        <textarea id=\"message\" name=\"message\" style=\"height: 100px; width: 100%;\"  ")
    ; __append(escapeFn(customMessageDisabled))
    ; __append(">")
    ; __append(escapeFn(message))
    ; __append("</textarea>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <input type=\"checkbox\" name=\"stopExecution\" value=\"stopExecution\" style=\"margin-right: 5px;\">Stop execution if check fails</input>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}